import { render, staticRenderFns } from "./modalJustificacionInactividad.vue?vue&type=template&id=591e9821"
import script from "./modalJustificacionInactividad.vue?vue&type=script&lang=js"
export * from "./modalJustificacionInactividad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports